<template>
  <div class="prizeset">
    <el-dialog title="惩罚设置" :visible.sync="dialogFormVisible" width="950px" :close-on-click-modal="false" @close="close">
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item label="指派单拒单惩罚" :required="true" prop="type">
          <el-radio v-model="form.type" label="1">全职</el-radio>
          <el-radio v-model="form.type" label="2">兼职</el-radio>
          <div class="flex numberip mar_b10" v-for="(item, index) in form.reject" :key="index">
            <div class>每日拒单区间（单）</div>
            <el-input-number v-model="item.startNum" controls-position="right" :min="0" :max="99999999" class></el-input-number>
            <div class="mar_lr10">~</div>
            <el-input-number v-model="item.endNum" controls-position="right" :min="0" :max="99999999" class></el-input-number>
            <div class="mar_lr10">罚款金额</div>
            <el-input-number v-model="item.money" controls-position="right" :min="0" :max="99999999" class></el-input-number>
            <div class="mar_lr10">元</div>
            <el-button size="mini" type="text" @click="delSpecMethod(index)" class="mar_l20">删除</el-button>
          </div>
          <el-button type="text" class @click="addSpecMethod" v-show="form.reject.length < 3">添加每日拒单惩罚区间</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="close">{{ $t('common.cancel') }}</el-button>
        <el-button size="medium" type="primary" @click="save">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getConfig, postConfig } from '@/api/set';
export default {
  name: 'labelSave',
  created() {},
  data() {
    return {
      form: {
        type: '1',

        reject: [
          {
            startNum: '',
            endNum: '',
            money: ''
          }
        ]
      },
      title: '',
      dialogFormVisible: false
    };
  },
  components: {},
  methods: {
    showEdit() {
      console.log(1111);
      // if (!row) {
      //   this.title = "添加";
      // } else {
      //   this.title = "编辑";
      //   this.init();
      // }
      this.dialogFormVisible = true;
      this.init();
    },
    close() {
      this.$refs['form'].resetFields();
      this.form = this.$options.data().form;
      this.dialogFormVisible = false;
    },
    addSpecMethod() {
      let specObj = {
        startNum: '',
        endNum: '',
        money: ''
      };
      this.$set(this.form.reject, this.form.reject.length, specObj);
    },
    delSpecMethod(index) {
      this.$delete(this.form.reject, index);
    },
    async init() {
      const { data } = await getConfig({ ident: 'sanction' });
      this.form2 = this.form;
      this.form = Object.assign(this.form2, data);
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.form.ident = 'sanction';
          const { msg } = await postConfig(this.form);
          this.$baseMessage(msg, 'success');
          this.$emit('fetchData');
          this.close();
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.prizeset {
  .time_item .el-input {
    width: 180px;
  }
  .numberip .el-input {
    width: 120px !important;
  }
  .numberip .el-input-number {
    width: 120px;
  }
}
</style>
